import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import AccountHeader from '../share/AccountHeader';
import AccountInformation from '../share/AccountInformation';
import {toastChange} from '~/modules/toast/actions';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import {
  getAccountList,
  saveUserRoleChange,
  deleteUserAndGetNewUserList,
  handleChangeUserRoleValue,
  hideAsyncErrorMessage,
} from '~/modules/adminAccountPage/actions';
import store from '~/store';
import Spinner from '~/components/common/Spinner';
import DropDown from '~/components/common/DropDown';
import LabeledInput from '~/components/common/LabeledInput';
import {MenuList, MenuListItem} from '~/components/common/MenuList';
import {hideErrorMsg} from '~/misc/hideErrorMsg';
import {track} from '~/misc/metrics';

import sharedCSS from '../share.css';
import css from './index.css';

const titles = {
  admin: 'Admin',
  user: 'User',
};

class MembershipManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentEditUserListId: '',
    };
    this.toggleUserRole = this.toggleUserRole.bind(this);
    this.saveAccountUser = this.saveAccountUser.bind(this);
    this.deleteAccountUser = this.deleteAccountUser.bind(this);
    this.addUserAndTrack = this.addUserAndTrack.bind(this);
  }
  componentDidMount() {
    track('my account', {'Membership manage': 1});
    this.dispatchGetAccountList();
  }

  render() {
    const accountInfo = this.props.adminAccountPage.accountInfo.data;
    const accountUserList = this.props.adminAccountPage.accountUserList;
    const totalSeatNum = Number(accountInfo.manageUsers);
    const usedSeatNum = (accountUserList.data && accountUserList.data.length)
      ? accountUserList.data.length
      : 0;
    const remainUserSeatNum = totalSeatNum ? (totalSeatNum - usedSeatNum) : 0;

    if (isEmpty(accountInfo)) {
      return (
        <div className={cs(sharedCSS.tr, sharedCSS.viewH)}>
          <div className={sharedCSS.spinnerLine}>
            <div className={sharedCSS.spinner}>
              <Spinner scalable={true}/>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <AccountHeader
          tit='Membership Information'
          titleInfo='Administrators have administrative privileges to manage users of your company.'
        />
        <AccountInformation msg={this.props.account.userInfo.data}/>
        <div className={css.userManage}>
          <div className={cs(css.userListWrap)}>
            <div className={cs(css.titleWrap, css.addLine)}>
              <div className={cs(css.flex1)}>No.</div>
              <div className={cs(css.flex3)}>Member Info</div>
              <div className={cs(css.flex1)}>Role</div>
              <div className={cs(css.flex1)}>Status</div>
              <div className={cs(css.flex1)}>Manage</div>
            </div>
            <div className={css.bodyWrap}>
              {
                this.renderUserList()
              }
            </div>
          </div>
          <div className={css.footer}>
            {
              this.renderAddUserBtn(remainUserSeatNum, totalSeatNum)
            }
            <div className={cs(css.details, sharedCSS.fontGrey)}>
              <p>
                You still have
                <span className={css.numPd}>
                  {remainUserSeatNum > 0 ? remainUserSeatNum : 0}
                </span>
                remaining seats
              </p>
              <p>More users, contact us by{' '}
                <a className={css.greyA} href='tel:+1 (757) 941-7806'>+1 (757) 941-7806</a>
              </p>
            </div>
          </div>
        </div>

      </div>
    );
  }

  renderUserList() {
    const accountUserList = this.props.adminAccountPage.accountUserList;
    const editAccountControlData = this.props.adminAccountPage.editAccountControlData;

    if (accountUserList.jumptoRoot){
      setTimeout(() => {
        location.href = location.origin;
      }, 1000);
    }

    if (accountUserList.loading) {
      return (
        <div className={cs(css.userListItemWrap, css.addLine)}>loading...</div>
      );
    }

    if (accountUserList.error) {
      return (
        <div
          className={cs(css.userListItemWrap, css.addLine)}
          onClick={this.dispatchGetAccountList}
        >{accountUserList.error}</div>
      );
    }
    if (accountUserList.data && accountUserList.data.length) {
      return accountUserList.data.map((item, index) => (
        <div className={cs(css.userListItemWrap, css.addLine)} key={item.id} id={item.id}>
          <div className={cs(css.flex1)}>{index + 1}</div>
          <div className={cs(css.flex3, css.userInfoWrap)}>
            <span className={css.emailStyle}>{item.email}</span>
            {(item.phone || item.lastName || item.firstName)
              && (
                <span className={css.phoneStyle}>
                  <em>{`${item.lastName && item.lastName} ${item.firstName && item.firstName}`}</em>
                  <em className={css.pdleft}>{item.phone && item.phone}</em>
                </span>
              )}
          </div>

          <div className={cs(css.flex1)}>
            <DropDown
              data-qa={`role-dropdown-${item.id}`}
              id={`role-dropdown-${item.id}`}
              wrapClassName={css.dropdown}
              closeByClick={true}
              trigger={
                <LabeledInput
                  data-qa={`dropdown-${item.id}-input`}
                  id={item.id}
                  large={true}
                  value={item.userRole ? titles[item.userRole.toLowerCase()] : 'User'}
                  icon='solidDropdown'
                  tags={false}
                  readOnly={true}
                  greyOutline={true}
                />
              }
              content={(
                <div className={cs(css.dropdownContent, css.itemWrap, css.overHid)}>
                  <MenuList multi={true} data-qa={`menu-list-${item.id}`}>
                    {Object.keys(titles).map((k, num) => (<MenuListItem
                      greyStyle={true}
                      className={
                        cs('qa-item', `qa-item-${k}`,
                          css.roleItem, this.initSelect(item.userRole, k) && css.selected)}
                      key={num + k}
                      name={item.userRole ? titles[item.userRole.toLowerCase()] : 'User'}
                      id={item.id}
                      num={num}
                      selected={this.initSelect(item.userRole, k)}
                      fn={this.toggleUserRole}
                      title={titles[k]}
                    />))}
                  </MenuList>
                </div>
              )}
            />
          </div>
          <div className={cs(css.flex1)}>{item.userStatus}</div>
          {item.changeBtn
            ? (<div
              className={cs(css.flex1, css.strong, css.deleteBtn)}
              data-changeBtn={true} id={item.id} data-userid={item.userId}
              data-role={item.userRole}
              onClick={!item.disable && this.saveAccountUser}
            >Save</div>)
            : (<div
              className={cs(css.flex1, css.strong, css.deleteBtn)}
              data-changeBtn={false} id={item.id} data-userid={item.userId}
              data-role={item.userRole}
              onClick={!item.disable && this.deleteAccountUser}
            >Delete</div>)
          }
          {(this.state.currentEditUserListId == item.id)
            && editAccountControlData.error
            && (<div ref='toastError' className={cs(css.toastTips, css.toastErrorTips)}>
              {
                hideErrorMsg(
                  'editAccountControlData',
                  this.props.adminAccountPage.editAccountControlData,
                  hideAsyncErrorMessage)
              }
            </div>)
          }
        </div>
      ));
    }
    return (
      <div className={cs(css.userListItemWrap, css.addLine)}>No Data</div>
    );
  }

  renderAddUserBtn(data, num) {
    if (data > 0) {
      return (<Button mods={['large']} onClick={this.addUserAndTrack}>Add Users</Button>);
    }
    return (<Button mods={['large']} onClick={() => this.props.toastUpgrade(num)}>Add Users</Button>);
  }

  dispatchGetAccountList() {
    return store.dispatch((dispatch, getState) => getAccountList(dispatch, getState));
  }

  addUserAndTrack() {
    track('my account', {'Membership manage - Add user': 1});
    return this.props.addUsers();
  }

  deleteAccountUser(e) {
    const editAccountControlData = this.props.adminAccountPage.editAccountControlData;
    if (editAccountControlData.error) {
      return null;
    }
    let changeBtn = (e.currentTarget.dataset.changebtn === 'true');
    const listData = this.props.adminAccountPage.accountUserList.data;
    const userInfo = find(listData, (value) => value.id === Number(e.target.id));
    const userId = e.currentTarget.dataset.userid;

    const userData = {
      isSelf: userId == this.props.user.id,
      id: e.target.id,
      changeBtn: changeBtn,
      accountEmail: this.props.adminAccountPage.accountInfo.data.accountEmail,
      email: userInfo.email,
    };
    return store.dispatch((dispatch, getState) => deleteUserAndGetNewUserList(dispatch, getState, userData));
  }

  saveAccountUser(e) {
    const editAccountControlData = this.props.adminAccountPage.editAccountControlData;
    if (editAccountControlData.error) {
      return null;
    }
    let changeBtn = (e.currentTarget.dataset.changebtn === 'true');
    const userId = e.currentTarget.dataset.userid;

    const val = {
      isSelf: userId == this.props.user.id,
      id: e.target.id,
      userRole: e.currentTarget.dataset.role,
      changeBtn: changeBtn,
    };
    this.setState({
      currentEditUserListId: e.target.id,
    });
    return store.dispatch((disable, getState) => saveUserRoleChange(disable, getState, val));
  }

  toggleUserRole(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.currentTarget.getAttribute('data-name').toLowerCase() === e.currentTarget.textContent.toLowerCase()) {
      return false;
    }
    return store.dispatch((dispatch, getState) => handleChangeUserRoleValue(dispatch, getState, {
      id: e.target.id,
      userRole: e.target.textContent.toLowerCase(),
    }));
  }

  initSelect(propsData, menuData) {
    if (propsData && (propsData.toLowerCase() === menuData.toLowerCase())) {
      return true;
    }
    return null;
  }
}

export default connect(null, mapDispatch({
  addUsers: () => modalChange(modes.ADDUSER, 'payment'),
  toastUpgrade: (props, num) => toastChange(
    'product-compare',
    `You can only add ${num} users. If you want to add more users. Contact us.`),
}))(MembershipManage);



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/MembershipManage/index.js